import React from 'react';
import { Box } from '@mui/material';

import { TemporaryLogout } from 'pages/MedicalInformation/style';
import PKDHeader from 'components/Home/Header';
import { useLogout } from 'hooks/useLogout';

export const PKDOnboardingLayout = ({ children, hasLogout = true }) => {
  const { handleLogout } = useLogout();

  return (
    <Box
      fontFamily='Montserrat'>
      <PKDHeader />
      {hasLogout && (
        <TemporaryLogout
          onClick={handleLogout}>Logout</TemporaryLogout>
      )}
      {children}
    </Box>
  );
};
